// extracted by mini-css-extract-plugin
export default {"close_icon_wrapper":"styles_close_icon_wrapper__V0ZFv","cancel_icon_wrapper":"styles_cancel_icon_wrapper__D+58R"};